import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_TERMS_OF_USE_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type { GetTermsOfUsePayload, GetTermsOfUseResult } from '../types/getTermsOfUse.types';

export const TERMS_OF_USE_TAGS = 'getTermsOfUse';

export const getTermsOfUse = (builder: BuilderType) =>
  builder.query<GetTermsOfUseResult, GetTermsOfUsePayload>({
    query: (data) => ({
      data,
      method: 'POST',
      url: GET_TERMS_OF_USE_URL,
    }),
    providesTags: [TERMS_OF_USE_TAGS],
    transformResponse: (response: GenericApiResponse<GetTermsOfUseResult>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }

      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
